import type { UseAccountActivityDataResponse } from '@mobi/api-types/account/transactions'

let hostHelpers: HostHelpers

/** Set host functions in module scope (NOT inside react) */
export function setHostHelpers(initHelpers: HostHelpers) {
  hostHelpers = initHelpers
}

export function getHostHelpers(): HostHelpers {
  return hostHelpers
}

// =====
// Types
// =====

export type HostHelpers = {
  triggerHapticFeedback: () => void
  useRefreshOnBetPlaced: () => void
  useAccountTransactionsData: ({
    selectedDate,
  }: {
    selectedDate?: string
  }) => UseAccountActivityDataResponse
  clearTransactionsCache: (selectedDate: string) => void
  updateAccountBalance: (balance?: { balance: string | number }) => void
}
